
import { motion } from 'framer-motion';

export default function WorksSection() {
  const works = [
    {
      category: 'イベント・展示会',
      title: 'イベント展示会ステージ設営',
      description: 'ピンクと白を基調とした鮮やかなステージデザインで、商品プロモーションイベントを華やかに演出。バルーン装飾やインタラクティブな展示要素で来場者の関心を高める空間設計',
      image: 'https://static.readdy.ai/image/c0a14dc189bb3eb0b6d6716d0af92e52/de0e82e8e22e672a8104f0bbe3b1a8a6.jfif'
    },
    {
      category: 'イベント・展示会',
      title: '展示会模擬店ブース設営',
      description: '伝統的な和の雰囲気を取り入れた展示会模擬店ブースの企画・設営。赤い提灯や和風装飾で来場者の目を引く魅力的な空間を演出し、体験型のイベント運営をサポート',
      image: 'https://static.readdy.ai/image/c0a14dc189bb3eb0b6d6716d0af92e52/efa08eb419af22a0a5e23f86092ccb2e.jfif'
    },
    {
      category: '文化・芸術イベント',
      title: '花道展会場設営',
      description: '日本の伝統文化である華道の美しさを最大限に引き出す展示会場の企画・設営。モダンな照明技術と伝統的な展示手法を融合させ、来場者が華道の奥深い世界を体感できる空間を創造',
      image: 'https://static.readdy.ai/image/c0a14dc189bb3eb0b6d6716d0af92e52/d622b58b90e57c27440866768b37c0fe.jfif'
    },
    {
      category: '商業施設・催事',
      title: 'デパート催事ブース設営',
      description: '海をテーマにした魅力的なデパート催事ブースの企画・設営。熱帯魚水族館風のディスプレイと自然の植栽を組み合わせ、お客様が海の世界に浸れる幻想的な空間を演出し、商品の魅力を最大限に引き出す',
      image: 'https://static.readdy.ai/image/c0a14dc189bb3eb0b6d6716d0af92e52/6a18a0f4fedba364aacb68473fcafea2.jfif'
    },
    {
      category: 'サイン・看板制作',
      title: '展示会サイン看板制作',
      description: '浮世絵をテーマにした文化展示会の大型看板制作。伝統的な日本文化の魅力を現代的なデザインで表現し、来場者の興味を引く視覚的インパクトのあるサイン看板を制作・設置',
      image: 'https://static.readdy.ai/image/c0a14dc189bb3eb0b6d6716d0af92e52/360ae49ae04a2eb7e62292ce0c58dc17.jfif'
    },
    {
      category: '映像制作・放送',
      title: 'テレビ舞台セット造作',
      description: '放送局向けテレビ番組用舞台セットの設計・制作・施工。モダンなデザインと機能性を両立したスタジオセットで、番組の魅力を最大限に引き出す空間を創造。照明・音響設備との調和も考慮した総合的な舞台演出',
      image: 'https://static.readdy.ai/image/c0a14dc189bb3eb0b6d6716d0af92e52/674230eba94a3048af7e5c0aebbec520.jfif'
    }
  ];

  return (
    <section id="works" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl font-bold text-gray-900 mb-4">実績紹介</h2>
          <p className="text-xl text-gray-600">多様な分野で積み重ねた実績をご紹介します</p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {works.map((work, index) => (
            <motion.div 
              key={work.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              whileHover={{ y: -10 }}
              className="bg-white rounded-2xl shadow-lg overflow-hidden"
            >
              <div className="relative h-56">
                <img 
                  src={work.image}
                  alt={work.title}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
                <div className="absolute top-4 left-4">
                  <span className="bg-blue-600 text-white px-3 py-1 rounded-full text-xs font-medium">
                    {work.category}
                  </span>
                </div>
                <div className="absolute bottom-4 left-4 right-4">
                  <h3 className="text-white font-bold text-lg mb-1">{work.title}</h3>
                </div>
              </div>
              
              <div className="p-6">
                <p className="text-gray-700 text-sm leading-relaxed">{work.description}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
